import { render, staticRenderFns } from "./coursesDetails.vue?vue&type=template&id=166fddf8&scoped=true"
import script from "./coursesDetails.vue?vue&type=script&lang=js"
export * from "./coursesDetails.vue?vue&type=script&lang=js"
import style0 from "./coursesDetails.vue?vue&type=style&index=0&id=166fddf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166fddf8",
  null
  
)

export default component.exports